import React from "react";
import { ThreeDotIcon } from "../../assets/icons";

const ChatInterFace = () => {
  return (
    <div className="w-full h-full py-3">
      <div className="flex h-screen  bg-gray-50 font-sans">
        <div className="w-64 border-r border-gray-200 bg-white p-4">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-semibold text-blue-900">Chats (1)</h2>
            <div className="flex items-center space-x-2">
              <span className="cursor-pointer">{ThreeDotIcon}</span>
              <button className="hover:text-blue-500">
                <i className="fas fa-pen"></i>
              </button>
            </div>
          </div>
          <div className="flex w-full items-center space-x-2">
            <img
              src="https://via.placeholder.com/40"
              alt="profile"
              className="w-10 h-10 rounded-full"
            />
            <div className="flex flex-col gap-1">
              <div className="flex items-center gap-2">
                <p className="font-semibold text-[14px] text-[#4B5563]">
                  Jane Doe
                </p>
                <span className="w-[62px] h-[20px] bg-[#e4e7f1] px-1 rounded text-[10px] font-semibold text-[#1E3A8A] flex justify-center items-center">
                  Manager
                </span>
              </div>
              <span className="text-[12px] text-[#4B5563] font-normal">
                Jane: How have you been.
              </span>
            </div>
          </div>
        </div>

        {/* Chat Box */}
        <div className="flex-1 flex flex-col bg-white">
          {/* Chat Header */}
          <div className="flex items-center justify-between p-4 border-b border-gray-200">
            <div className="flex items-center space-x-2">
              <img
                src="https://via.placeholder.com/40"
                alt="profile"
                className="w-10 h-10 rounded-full"
              />
              <div>
                <p className="font-medium text-gray-900">Jane Doe</p>
                <span className="text-xs text-gray-500">Active 2 min ago</span>
              </div>
              <span className="w-[62px] h-[20px] bg-[#e4e7f1] px-1 rounded text-[10px] font-semibold text-[#1E3A8A] flex justify-center items-center">
                Manager
              </span>
            </div>
            <button className="text-gray-500 hover:text-gray-800">
              <i className="fas fa-phone"></i>
            </button>
          </div>

          {/* Chat Messages */}
          <div className="flex-1 overflow-y-auto p-4 space-y-4">
            {/* Jane's Message */}
            <div className="flex items-start space-x-2">
              <img
                src="https://via.placeholder.com/40"
                alt="profile"
                className="w-8 h-8 rounded-full"
              />
              <div className="bg-gray-100 px-3 py-2 rounded-lg">
                <p className="text-gray-800">How have you have been.</p>
              </div>
            </div>

            {/* User Reply */}
            <div className="flex items-center justify-end space-x-2">
              <div className="bg-blue-100 px-3 py-2 rounded-lg">
                <p className="text-gray-800">I’m good.</p>
              </div>
              <img
                src="https://via.placeholder.com/40"
                alt="user"
                className="w-8 h-8 rounded-full"
              />
            </div>
          </div>

          {/* Input Box */}
          <div className="border-t border-gray-200 p-4 flex items-center space-x-4">
            <button className="text-gray-500 hover:text-blue-500">
              <i className="fas fa-plus"></i>
            </button>
            <button className="text-gray-500 hover:text-blue-500">
              <i className="fas fa-paperclip"></i>
            </button>
            <input
              type="text"
              placeholder="Aa"
              className="flex-1 border rounded-full px-4 py-2 focus:outline-none"
            />
            <button className="text-gray-500 hover:text-blue-500">
              <i className="fas fa-smile"></i>
            </button>
            <button className="text-gray-500 hover:text-blue-500">
              <i className="fas fa-thumbs-up"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatInterFace;
